// @ts-nocheck
import React, { useState } from 'react';
import { Alert, Container } from 'reactstrap';


const AlertAPI = (props:any) => {
	const [alert, setAlert] = useState(true);

	return (
		<Alert
			className="alert-with-icon"
			variant={props.variant}
			isOpen={alert}
		>
			<Container>
				<div className="alert-wrapper">
					<button
						type="button"
						className="close"
						data-dismiss="alert"
						aria-label="Close"
						onClick={() => setAlert(false)}
					>
						<i className="nc-icon nc-simple-remove" />
					</button>
					<div className="message">
						<i className="nc-icon nc-bell-55" /> {props.text}
					</div>
				</div>
			</Container>
		</Alert>
	)
}

export default AlertAPI;